module.exports = __webpack_public_path__ + "media/shock.56479e39.aac";